import React, { useEffect } from "react";
import Video from "../molecules/Video";
import Proposito from "../molecules/Proposito";
import Funciones from "../molecules/Funciones";
import Bienvenida from "../molecules/Bienvenida";
import Plataforma from "../molecules/Plataforma";
import Testimonios from "../molecules/Testimonios";
import Planes from "../molecules/Planes";
import Partners from "../molecules/Partners";
import Contacto from "../molecules/Contacto";
import { useScrollContext } from "./Scrollprovider";

export const Home = () => {
  const { shouldScroll, setShouldScroll } = useScrollContext();

  useEffect(() => {
    if (shouldScroll) {
      const contactSection = document.getElementById("contact");
      if (contactSection) {
        contactSection.scrollIntoView({ behavior: "smooth" });
      }
      setShouldScroll(false);
    }
  }, [shouldScroll, setShouldScroll]);

  return (
    <>
      <div className="App">
        <Video />
        <Proposito />
        <Funciones />
        <Bienvenida />
        <Plataforma />
        <Testimonios />
        <Planes />
        <Partners />
        <section id="contact">
          <Contacto />
        </section>
      </div>
    </>
  );
};

export default Home;
